 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A0_COVER from '@/components/00_cover'
 import A1_TITLE from '@/components/01_title'
 import A2_COPYRIGHT from '@/components/02_copyright'
 import A3_CONTENTS from '@/components/03_contents'
 import A4_INTRODUCTION from '@/components/04_introduction'
 import A5_PART01 from '@/components/05_part01'
 import A6_PART02 from '@/components/06_part02'
 import A7_PART03 from '@/components/07_part03'
 import A8_PART04 from '@/components/08_part04'
 import A9_PART05 from '@/components/09_part05'
 import A0_PART06 from '@/components/10_part06'
 import A1_PART07 from '@/components/11_part07'
 import A2_PART08 from '@/components/12_part08'
 import A3_PART09 from '@/components/13_part09'
 import A4_PART10 from '@/components/14_part10'
 import A5_PART11 from '@/components/15_part11'
 import A6_PART12 from '@/components/16_part12'
 import A7_PART13 from '@/components/17_part13'
 import A8_BIBLIOGRAPHY from '@/components/18_bibliography'
 import A9_ABOUTTHEAUTHORS from '@/components/19_abouttheauthors'
 import A0_TOOURREADERS from '@/components/20_toourreaders'
 import A1_BONUSMATERIAL from '@/components/21_bonusmaterial'
 import A2_FOREWORD from '@/components/22_foreword'
 import A3_INTRODUCTION from '@/components/23_introduction'
 import A4_BACKCOVER from '@/components/24_backcover'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/03_contents",
 			"name" : "03_contents",
 			"component" : A3_CONTENTS
 		},
 		{
 			"path" : "/04_introduction",
 			"name" : "04_introduction",
 			"component" : A4_INTRODUCTION
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js